import { ReduceCapacityTwoTone } from "@mui/icons-material";
import { MONTHS } from "../constants/months";
import { stateToHTML } from 'draft-js-export-html';
import htmlToDraft from 'html-to-draftjs';
import { EditorState,ContentState,convertToRaw,Modifier } from 'draft-js'
import { toast } from "react-toastify";

function exportCleanHTML(html) {
  if (!html) return "";

  // Step 1: Remove span/style/class/&nbsp;
  html = html
    .replace(/<span[^>]*style="[^"]*"[^>]*>/gi, "")
    .replace(/<\/span>/gi, "")
    .replace(/\sstyle="[^"]*"/gi, "")
    .replace(/\sclass="[^"]*"/gi, "")
    .replace(/&nbsp;/gi, " ");

  // Step 2: Extract all <img> tags
  const imgTags = [];
  html = html.replace(/<img[^>]*>/gi, (match) => {
    imgTags.push(match);
    return ""; // remove from inline position
  });

  // Step 3: Remove all other tags
  html = html.replace(/<[^>]*>/g, "");

  // Step 4: Normalize spaces
  html = html.replace(/\s+/g, " ").trim();

  // Step 5: Append images at the end
  if (imgTags.length > 0) {
    html += " " + imgTags.join(" ");
  }

  return html.trim();
}


function cleanUnusedEntities(rawContent) {
    const usedEntityKeys = new Set();

    // Collect used entity keys from blocks
    rawContent.blocks.forEach(block => {
        if (block.entityRanges && block.entityRanges.length > 0) {
            block.entityRanges.forEach(range => {
                if (range.key !== undefined) {
                    usedEntityKeys.add(String(range.key));
                }
            });
        }
    });

    // Rebuild entityMap with only used entities
    const newEntityMap = {};
    for (const key in rawContent.entityMap) {
        if (usedEntityKeys.has(key)) {
            newEntityMap[key] = rawContent.entityMap[key];
        }
    }

    return {
        ...rawContent,
        entityMap: newEntityMap
    };
}
const TOKEN = "token1";
const NAME = "name";
const PHONE = "phone";
const DRAFT = "draft";
const ASSESSMENT = "assessment";
const ANSWERS = "answers";
const CANDIDATE_NAME = "candidate_name";
const PROFILE_PIC = "profile_pic";
const saveToken = (token) => {
  localStorage.setItem(TOKEN, token);
};
const getToken = () => {
  return localStorage.getItem(TOKEN);
};
const deleteToken = () => {
  localStorage.removeItem(TOKEN);
  // The cached photo belongs to this trainer; don't show it to the next one.
  localStorage.removeItem(PROFILE_PIC);
};
const isLoggedIn = () => {
  return localStorage.getItem(TOKEN) !== null;
};
const saveName = (name) => {
  localStorage.setItem(NAME, name);
};
const getName = () => {
  return localStorage.getItem(NAME);
};
// The header avatar's photo, cached so a page load shows it straight away
// instead of the initial first. Saving notifies the header so an upload on the
// profile page updates it without a reload.
const saveProfilePic = (url) => {
  if (url) localStorage.setItem(PROFILE_PIC, url);
  else localStorage.removeItem(PROFILE_PIC);
  window.dispatchEvent(new Event("tk-profile-pic"));
};
const getProfilePic = () => {
  return localStorage.getItem(PROFILE_PIC);
};
const saveDraft = (draft) => {
  localStorage.setItem(DRAFT, JSON.stringify(draft));
};
const getDraft = () => {
  return JSON.parse(localStorage.getItem(DRAFT));
};
// Remove the item
const removeDraft = () => {
  console.log("removed");
  localStorage.removeItem(DRAFT);
};
const saveCandidateName = (toSave) => {
  localStorage.setItem(CANDIDATE_NAME, JSON.stringify(toSave));
};
const getCandidateName = () => {
  return JSON.parse(localStorage.getItem(CANDIDATE_NAME));
};
const deleteCandidate = () => {
  localStorage.removeItem(CANDIDATE_NAME);
};
const isCandidateExists = () => {
  return localStorage.getItem(CANDIDATE_NAME) !== null;
};
const isDraftExists = () => {
  return localStorage.getItem(DRAFT) !== null;
};
const savePhone = (name) => {
  localStorage.setItem(PHONE, name);
};
const getPhone = () => {
  return localStorage.getItem(PHONE);
};

const saveAssessment = (assessment) => {
  localStorage.setItem(ASSESSMENT, JSON.stringify(assessment));
};
const getAssessment = () => {
  return JSON.parse(localStorage.getItem(ASSESSMENT));
};
const isAssessmentExists = () => {
  return localStorage.getItem(ASSESSMENT) !== null;
};
const saveAnswers = (ans) => {
  localStorage.setItem(ANSWERS, JSON.stringify(ans));
};
const getAnswers = () => {
  return JSON.parse(localStorage.getItem(ANSWERS));
};
const answerExists = () => {
  return localStorage.getItem(ANSWERS) !== null;
};

export const isAssessmentCompleted = () => {
  if (answerExists()) {
    let asm = getAnswers();
    return asm.completed ? true : false;
  } else {
    return false;
  }
};

const shuffleFisherYates = (arr) => {
  for (var i = arr.length - 1; i > 0; i--) {
    var j = Math.floor(Math.random() * (i + 1)); //random index
    [arr[i], arr[j]] = [arr[j], arr[i]]; // swap
  }
  return arr;
};
const checkColumns = (cols) => {
  if (cols.length !== 14) {
    return false;
  } else {
    if (
      cols[0] != "question" ||
      cols[1] != "optionA" ||
      cols[2] != "isOptionACorrect" ||
      cols[3] != "optionB" ||
      cols[4] != "isOptionBCorrect" ||
      cols[5] != "optionC" ||
      cols[6] != "isOptionCCorrect" ||
      cols[7] != "optionD" ||
      cols[8] != "isOptionDCorrect" ||
      cols[9] != "optionE" ||
      cols[10] != "isOptionECorrect" ||
      cols[11] != "optionF" ||
      cols[12] != "isOptionFCorrect" ||
      cols[13] != "Topic"
    ) {
      return false;
    }
  }
  return true;
};
const optionChecker = (c, d, e, f) => {
  let cond1 = d !== "" && c !== "";
  let cond2 = e !== "" && cond1;
  let cond3 = f !== "" && cond2;
  let cond4 = f !== "" || e !== "" || d !== "";
  let cond = cond4 && (cond3 || cond2 || cond1);
  return cond;
};
// Tags and attributes a question or option may legitimately contain. Anything
// outside this list is unwrapped (children kept) or dropped.
const ALLOWED_TAGS = new Set([
  "B","STRONG","I","EM","U","S","STRIKE","SUB","SUP","BR","P","DIV","SPAN",
  "UL","OL","LI","TABLE","THEAD","TBODY","TFOOT","TR","TD","TH","CAPTION",
  "PRE","CODE","BLOCKQUOTE","H1","H2","H3","H4","H5","H6","IMG","A","HR","FONT",
]);
const ALLOWED_ATTRS = new Set([
  "src","alt","title","width","height","align","colspan","rowspan","class","style","href","target","rel","color","face",
]);
const DROP_ENTIRELY = new Set([
  "SCRIPT","IFRAME","OBJECT","EMBED","LINK","META","STYLE","SVG","MATH","FORM","INPUT","BUTTON","TEXTAREA","SELECT","BASE","AUDIO","VIDEO","SOURCE",
]);
const SAFE_URL = /^(https?:|data:image\/(png|jpe?g|gif|webp|bmp|svg\+xml);|mailto:|tel:|\/|\.\/|#)/i;

// Sanitise a stored HTML fragment for rendering.
//
// This used to only strip empty tags, while still doing `wrapper.innerHTML =
// html` on untrusted input — which is enough for `<img src=x onerror=…>` to
// fire, since browsers begin loading images even for detached nodes. Question
// and option HTML is authored by trainers and imported from Excel, then shown
// to candidates, so that was a stored-XSS path between accounts.
const cleanO = (html) => {
  if (!html || (typeof html !== "string" && typeof html !== "number")) return "";

  const wrapper = document.createElement("div");
  wrapper.innerHTML = String(html);

  // --- strip anything executable -------------------------------------
  const sanitise = (parent) => {
    [...parent.childNodes].forEach((node) => {
      if (node.nodeType === 8) return node.remove();      // comments
      if (node.nodeType !== 1) return;                     // keep text nodes

      if (DROP_ENTIRELY.has(node.tagName)) return node.remove();

      if (!ALLOWED_TAGS.has(node.tagName)) {
        // Unknown tag: keep what it wrapped, discard the tag itself.
        sanitise(node);
        while (node.firstChild) parent.insertBefore(node.firstChild, node);
        return node.remove();
      }

      [...node.attributes].forEach((attr) => {
        const name = attr.name.toLowerCase();
        const value = attr.value || "";
        // every on* handler, plus anything not explicitly allowed
        if (name.startsWith("on") || !ALLOWED_ATTRS.has(name)) {
          return node.removeAttribute(attr.name);
        }
        if ((name === "src" || name === "href") && !SAFE_URL.test(value.trim())) {
          return node.removeAttribute(attr.name);   // javascript:, vbscript:, …
        }
        if (name === "style" && /expression\(|javascript:|url\s*\(\s*['"]?\s*(?!data:image)/i.test(value)) {
          return node.removeAttribute(attr.name);
        }
      });

      if (node.tagName === "A") {
        // Stop reverse-tabnabbing on any link that opens a new tab.
        node.setAttribute("rel", "noopener noreferrer nofollow");
      }

      sanitise(node);
    });
  };
  sanitise(wrapper);

  // --- then the original behaviour: drop tags that render to nothing ---
  const cleanNodes = (parent) => {
    [...parent.childNodes].forEach(node => {
      if (
        node.nodeType === 1 && // element
        node.tagName !== 'IMG' &&
        node.textContent.trim() === '' &&
        !node.querySelector('img')
      ) {
        node.remove();
      } else if (node.childNodes.length > 0) {
        cleanNodes(node);
      }
    });
  };
  cleanNodes(wrapper);

  return wrapper.innerHTML.trim();
};

const checkRows = (row) => {
  if (row.length !== 14) {
    return false;
  } else {
    return !isEmpty(row[0]) || !isEmpty(row[1]) || !isEmpty(row);
  }
};
const getDateFormatWithoutTIme = (d) => {
  var months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  let y = d.getFullYear();
  let dd = "0" + d.getDate();
  return (
    dd.slice(-2) +
    " " +
    months[d.getMonth()] +
    " " +
    y
  );
};
const getDateFormat = (d) => {
  var months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  let y = d.getFullYear();
  let dd = "0" + d.getDate();
  let h = d.getHours();
  let min = "0" + d.getMinutes();
  let period = h >= 12 ? "PM" : "AM";
  h = h % 12 || 12; // Convert 24-hour format to 12-hour format

  return (
    dd.slice(-2) +
    " " +
    months[d.getMonth()] +
    " " +
    y +
    ", " +
    ("0" + h).slice(-2) +
    ":" +
    min.slice(-2) +
    " " +
    period
  );
};

const getColor = (pc) => {
  if (pc < 10) return "red";
  else if (pc < 50 && pc >= 10) {
    return "orange";
  } else if (pc >= 50 && pc < 70) {
    return "orange";
  } else {
    return "green";
  }
};
// Same performance semantics as getColor, but with lighter shades that stay
// legible on a dark/coloured background (e.g. the purple Average-Score box).
const getColorOnDark = (pc) => {
  if (pc < 10) return "#FF8A80"; // light red
  else if (pc < 70) return "#FFD166"; // light amber
  else return "#7BE495"; // light green
};
const getHeader = () => {
  return {
    headers: {
      "content-type": "application/json",
      token: getToken(),
    },
  };
};
const getMonth = (ind) => {
  return MONTHS[ind];
};
function isEmpty(str) {
  return str === "" || str === null;
}
class MockTestA extends Array {
  sum(key) {
    return this.reduce((a, b) => parseInt(a) + (parseInt(b[key]) || 0), 0);
  }
}
const getRemainingDays = (planO) => {
  let date = new Date(planO.createdOn);
  let now = new Date();
  let daysdiff = (now.getTime() - date.getTime()) / (1000 * 60 * 60 * 24);
  let daysremaining = parseInt(planO.validity) - parseInt(daysdiff);
  return daysremaining;
};
const getRemainingMin = (endDate) => {
  endDate= new Date(endDate);
  let now = new Date();
  let minsRemaining = (endDate.getTime() - now.getTime()) / (1000 * 60);
  return minsRemaining;
};
function calculateMarkedPrice(cp, discount) {
  let mp = cp / (1 - discount / 100);
  return Math.floor(mp);
}
export {
  calculateMarkedPrice,
  getRemainingDays,
  saveAnswers,
  MockTestA,
  getHeader,
  getMonth,
  deleteCandidate,
  saveCandidateName,
  getCandidateName,
  isCandidateExists,
  getAnswers,
  answerExists,
  saveAssessment,
  getAssessment,
  isAssessmentExists,
  saveDraft,
  isDraftExists,
  getDraft,
  removeDraft,
  saveToken,
  cleanO,
  savePhone,
  getPhone,
  getDateFormat,
  getDateFormatWithoutTIme,
  shuffleFisherYates,
  checkColumns,
  checkRows,
  getToken,
  saveName,
  getName,
  saveProfilePic,
  getProfilePic,
  isLoggedIn,
  deleteToken,
  optionChecker,
  getColor,
  getColorOnDark,
  getRemainingMin,
  exportCleanHTML,
  cleanUnusedEntities,
  
};
